let instance = null;

class StatsD {
  constructor() {
    if (instance) {
      return instance;
    }
    try {
      this.fetch = window.fetch.bind(window);
    } catch (e) {
      console.log(e);
      this.fetch = window.fetch;
    }
    // override if we're on the demo site.
    if ('standardFetch' in window) {
      this.fetch = window.standardFetch.bind(window);
    }
    this.baseUrl = __BASE_URL__;
    this.debug = __DEV__;
    instance = this;
    return instance;
  }

  static getKey(key) {
    return `timeclock.${key}`;
  }

  request(type, body) {
    if (process.env.NODE_ENV === 'test') {
      return null;
    }

    if (process.env.BRANCH_SLUG !== 'master') {
      return null;
    }

    return this.fetch(`${this.baseUrl}/statsd/${type}`, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
      },
    });
  }

  log(type, key) {
    if (this.debug) {
      console.log(`statsd ${type}: ${key}`);
    }
  }

  increment(key) {
    this.request('increment', { tracking_key: StatsD.getKey(key) });
    this.log('increment', key);
  }

  measure(key, value) {
    this.request('measure', {
      tracking_key: StatsD.getKey(key),
      measurement: value,
    });
    this.log('measurement', key);
  }

  gauge(key, value) {
    this.request('guage', {
      tracking_key: StatsD.getKey(key),
      measurement: value,
    });
    this.log('guage', key);
  }
}

export default new StatsD();




// WEBPACK FOOTER //
// ./src/lib/StatsD.js